/* Native Shopify forms remain the fallback when JavaScript is unavailable. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const status = document.createElement('div');
  status.className = 'tf-toast'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.hidden = true;
  document.addEventListener('DOMContentLoaded', () => document.body.append(status), { once: true });
  let toastTimer;
  const toast = text => { status.textContent = text; status.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(() => { status.hidden = true; }, 4000); };
  document.querySelectorAll('.tf-reviews__app').forEach(region => {
    const bind = () => region.querySelector('.AirReviews-Blocks__ListReview')?.setAttribute('data-tf-track', '');
    bind();
    new MutationObserver(bind).observe(region, { childList: true, subtree: true });
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-tf-open-rewards]')) return;
    event.preventDefault();
    event.stopPropagation();
    const launcher = document.querySelector('button[aria-label="Open rewards"]');
    if (launcher) launcher.click();
    else toast('Rewards are loading. Please try again shortly.');
  }, true);
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-tf-next], [data-tf-prev]');
    if (arrow) { const track = arrow.closest('[data-tf-carousel]')?.querySelector('[data-tf-track]'); if (!track) return; const child = track.firstElementChild; const gap = parseFloat(getComputedStyle(track).gap) || 0; const width = child ? child.getBoundingClientRect().width + gap : track.clientWidth; track.scrollBy({ left: width * (arrow.hasAttribute('data-tf-prev') ? -1 : 1) * (getComputedStyle(track).direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
    const tab = event.target.closest('[data-tf-tab]');
    if (tab) { const parent=tab.closest('[data-tf-tabs]'); parent.querySelectorAll('[data-tf-tab]').forEach(t => { t.setAttribute('aria-selected',String(t===tab)); t.tabIndex=t===tab?0:-1; }); parent.querySelectorAll('[data-tf-panel]').forEach(p => { p.hidden=p.id!==tab.getAttribute('aria-controls'); }); }
    const thumb=event.target.closest('[data-tf-thumb]');
    if(thumb){const gallery=thumb.closest('[data-tf-gallery]'); gallery.querySelectorAll('[data-tf-media]').forEach(m=>{m.hidden=m.id!==thumb.getAttribute('aria-controls');if(m.hidden)m.querySelectorAll('video').forEach(v=>v.pause());});gallery.querySelectorAll('[data-tf-thumb]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));}
  });
  document.addEventListener('keydown', event => {
    if(event.key==='Escape') document.querySelectorAll('.tf-header details[open]').forEach(d=>{d.open=false;d.querySelector('summary')?.focus();});
    const tab=event.target.closest('[data-tf-tab]');if(!tab||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const tabs=[...tab.closest('[data-tf-tabs]').querySelectorAll('[data-tf-tab]')];let i=tabs.indexOf(tab);i=event.key==='Home'?0:event.key==='End'?tabs.length-1:(i+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;tabs[i].click();tabs[i].focus();
  });
  document.addEventListener('change', event => {
    if(event.target.matches('[data-tf-language]'))event.target.form.submit();
    if(event.target.matches('[data-tf-card-variant]')){const option=event.target.selectedOptions?event.target.selectedOptions[0]:event.target,card=event.target.closest('[data-tf-card]');const button=card.querySelector('[type="submit"]');if(button){button.disabled=option.disabled;if(!option.disabled&&button.dataset.tfAvailableLabel){button.innerHTML=button.dataset.tfAvailableLabel;}}const discountBadge=card.querySelector('[data-tf-discount-badge]');if(discountBadge){const price=Number(option.dataset.priceCents),comparePrice=Number(option.dataset.compareCents),percent=comparePrice>price&&comparePrice>0?Math.round((comparePrice-price)*100/comparePrice):0;discountBadge.hidden=percent<=0;discountBadge.textContent=(document.documentElement.lang.startsWith('ar')?'خصم ':'Save ')+percent+'%';}card.querySelector('[data-tf-card-price]').textContent=option.dataset.price;const image=card.querySelector('.tf-product-card__media img');if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.imageAlt||image.alt;}const compare=card.querySelector('[data-tf-card-compare]');if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=option.dataset.hasCompare!=='true';}}
    if(event.target.matches('[data-tf-variant]')){
      const region=event.target.closest('[data-tf-product]');const variant=JSON.parse(region.querySelector('[data-tf-variants]').textContent).find(v=>String(v.id)===event.target.value);if(!variant)return;
      region.querySelectorAll('input[name="id"]').forEach(input=>input.value=variant.id);
      region.querySelectorAll('[data-tf-product-price]').forEach(el=>el.textContent=variant.formatted_price);
      region.querySelectorAll('[data-tf-product-compare]').forEach(el=>{el.textContent=variant.formatted_compare||'';el.hidden=!(variant.compare_at_price>variant.price);});
      region.querySelectorAll('[data-tf-purchase-button]').forEach(el=>{el.disabled=!variant.available;el.querySelector('[data-tf-purchase-label]').textContent=variant.available?'Add to Box':'Sold out';});
      region.querySelector('[data-tf-stock]').textContent=variant.available?'In stock — ready for your routine':'Sold out';
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      if(variant.featured_media){const thumb=region.querySelector(`[data-tf-thumb][data-media-id="${variant.featured_media.id}"]`);thumb?.click();}
    }
  });
  document.addEventListener('submit', async event => {
    const form=event.target;if(!form.matches('[data-tf-add]'))return;
    if(form.querySelector('input[name="selling_plan"]')?.required&&!form.querySelector('input[name="selling_plan"]').value)return;
    event.preventDefault();const button=event.submitter||form.querySelector('[type="submit"]'),error=form.querySelector('[data-tf-error]');if(button.disabled)return;button.disabled=true;button.setAttribute('aria-busy','true');if(error)error.hidden=true;
    const add=async()=>{const data=new FormData(form);if(form.dataset.tfOnePerCustomer==='true'){const cartCheck=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!cartCheck.ok)throw new Error('Unable to check your box. Please try again.');const current=await cartCheck.json();if(current.items?.some(item=>String(item.variant_id||item.id)===String(data.get('id'))))throw new Error('This offer is limited to one per customer.');}const response=await fetch(root+'cart/add.js',{method:'POST',body:data,credentials:'same-origin',headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'Unable to add this item.');try{const cartResponse=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-tf-cart-count]').forEach(el=>el.textContent=cart.item_count);}document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:false}}));}catch{document.querySelectorAll('[data-tf-cart-count]').forEach(el=>{el.textContent=Number(el.textContent)+(result.quantity||1);});}toast('Added to your box');return result;};
    try{if(window.TallahCart?.enqueue)await window.TallahCart.enqueue(add);else await add();}catch(err){if(error){error.textContent=err.message;error.hidden=false;}else toast(err.message);}finally{button.disabled=false;button.removeAttribute('aria-busy');}
  });
  document.querySelectorAll('[data-tf-gift-date]').forEach(el=>{const d=new Date();el.min=[d.getFullYear(),String(d.getMonth()+1).padStart(2,'0'),String(d.getDate()).padStart(2,'0')].join('-');});document.querySelectorAll('[data-tf-timezone]').forEach(el=>el.value=new Date().getTimezoneOffset());
})();

/* Figma component entry/exit: leave to the right, then reset off the left.
   Event delegation only; no cart, form, link, app or catalogue handlers replaced. */
(() => {
  if (window.TallahComponentMotion) return;
  window.TallahComponentMotion = true;
  const selector = '#MainContent :is(.tf-hero__slide>.tf-button,.tf-category__action,.tf-concern__action,.tf-banner>.tf-button,.tf-gift-promo .tf-button,.tf-brands .tf-section-heading .tf-button,.tf-videos:not(.tf-videos--dark) .tf-button,.tf-categories .tf-section-heading .tf-button--outline,.tf-profile-primary,.tf-profile-signin,.tf-gift-page .tf-button--pink,.tf-verify-page .tf-button--pink,.tf-wishlist-start),#CartDrawer .drawer__footer-buttons :is(.btn--primary,.btn--secondary)';
  const timers = new WeakMap(), active = new WeakSet();
  const fine = matchMedia('(hover:hover) and (pointer:fine)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const find = target => target instanceof Element ? target.closest(selector) : null;
  const enabled = el => el && !el.matches(':disabled,[aria-disabled="true"],.is-disabled');
  function enter(el) {
    if (!enabled(el)) return;
    clearTimeout(timers.get(el));
    el.classList.remove('tf-hover-leaving');
    active.add(el);
  }
  function leave(el) {
    if (!enabled(el) || !active.has(el) || el.matches(':focus-visible')) return;
    active.delete(el);
    clearTimeout(timers.get(el));
    if (reduced.matches) { el.classList.remove('tf-hover-leaving'); return; }
    el.classList.add('tf-hover-leaving');
    timers.set(el, setTimeout(() => {
      el.classList.remove('tf-hover-leaving');
      timers.delete(el);
    }, 640));
  }
  document.documentElement.classList.add('tf-interactions-motion');
  document.addEventListener('pointerover', event => {
    if (!fine.matches || event.pointerType === 'touch') return;
    const el = find(event.target);
    if (el && !el.contains(event.relatedTarget)) enter(el);
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    if (!fine.matches || event.pointerType === 'touch') return;
    const el = find(event.target);
    if (el && !el.contains(event.relatedTarget)) leave(el);
  }, { passive: true });
  document.addEventListener('focusin', event => {
    const el = find(event.target);
    if (el) enter(el);
  });
  document.addEventListener('focusout', event => {
    const el = find(event.target);
    if (el && !el.contains(event.relatedTarget) && !el.matches(':hover')) leave(el);
  });
})();

/* Continuous TikTok rail. Native video/catalog behavior stays in place. */
(() => {
  if (window.TallahTikTokAutoscroll) return;
  window.TallahTikTokAutoscroll = true;
  const controllers = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function bind(section) {
    const track = section.querySelector('.tf-videos__track');
    if (!track || controllers.has(section) || track.children.length < 2) return;
    const original = [...track.children];
    // Liquid renders two identical sets for the light TikTok section.
    const source = original.slice(0, Math.floor(original.length / 2));
    if (!source.length) return;
    track.style.setProperty('scroll-snap-type', 'none', 'important');
    track.style.setProperty('scroll-behavior', 'auto', 'important');
    let cycle = 0, position = track.scrollLeft, frame = 0, last = 0;
    let visible = false, hovering = false, dragging = false, pauseUntil = 0, motion = null;
    const playing = new Set();
    const wrap = value => cycle ? ((value % cycle) + cycle) % cycle : 0;
    function measure() {
      const first = track.children[0], repeat = track.children[source.length];
      if (!first || !repeat) return;
      cycle = repeat.offsetLeft - first.offsetLeft;
      if (cycle <= 0) return;
      // Wide desktops need a complete extra cycle beyond the viewport.
      let copies = 0;
      while (track.scrollWidth - track.clientWidth < cycle + 2 && copies++ < 16) {
        source.forEach(card => {
          const clone = card.cloneNode(true);
          clone.dataset.tfVideoCopy = 'true';
          [clone, ...clone.querySelectorAll('[id],[data-shopify-editor-block]')].forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('video').forEach(video => { video.controls = false; });
          track.append(clone);
        });
      }
      position = wrap(track.scrollLeft);
    }
    function tick(now) {
      frame = 0;
      const dt = last ? Math.min((now - last) / 1000, .05) : 0;
      last = now;
      if (motion) {
        const progress = Math.min((now - motion.start) / 380, 1);
        position = wrap(motion.from + motion.delta * (1 - Math.pow(1 - progress, 3)));
        track.scrollLeft = position;
        if (progress === 1) motion = null;
      } else if (!reduced.matches && !hovering && !dragging && !playing.size &&
                 !section.contains(document.activeElement) && now >= pauseUntil) {
        position = wrap(position + dt * 28);
        track.scrollLeft = position;
      } else position = track.scrollLeft;
      if (visible && !document.hidden) frame = requestAnimationFrame(tick);
    }
    function schedule() {
      if (visible && !document.hidden && !frame) { last = 0; frame = requestAnimationFrame(tick); }
      else if ((!visible || document.hidden) && frame) { cancelAnimationFrame(frame); frame = 0; last = 0; }
    }
    const pause = () => { pauseUntil = performance.now() + 2500; motion = null; position = track.scrollLeft; };
    track.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') hovering = true; });
    track.addEventListener('pointerleave', () => { hovering = false; dragging = false; });
    track.addEventListener('pointerdown', () => { dragging = true; pause(); }, { passive: true });
    track.addEventListener('pointerup', () => { dragging = false; pause(); }, { passive: true });
    track.addEventListener('pointercancel', () => { dragging = false; pause(); }, { passive: true });
    track.addEventListener('wheel', pause, { passive: true });
    track.addEventListener('keydown', pause);
    track.addEventListener('play', event => {
      playing.add(event.target); pause();
      track.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
    }, true);
    ['pause', 'ended', 'emptied'].forEach(type => track.addEventListener(type, event => playing.delete(event.target), true));
    // Copies added for wide screens use the same play UI as the original cards.
    track.addEventListener('click', event => {
      const button = event.target.closest('[data-tf-video-copy] .tf-video__start');
      if (!button) return;
      const video = button.closest('.tf-video').querySelector('video');
      if (!video) return;
      video.controls = true;
      video.play().then(() => { button.hidden = true; }).catch(() => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; video.controls = false; }, { once: true });
    });
    section.addEventListener('click', event => {
      const arrow = event.target.closest('[data-tf-next],[data-tf-prev]');
      if (!arrow || !cycle) return;
      event.preventDefault();
      event.stopPropagation();
      const first = track.firstElementChild;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      pause();
      const delta = step * (arrow.hasAttribute('data-tf-prev') ? -1 : 1);
      if (reduced.matches) { position = wrap(track.scrollLeft + delta); track.scrollLeft = position; }
      else { motion = { from: track.scrollLeft, delta, start: performance.now() }; schedule(); }
    }, true);
    measure();
    const resize = new ResizeObserver(measure);
    resize.observe(track);
    const intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
    intersection.observe(section);
    document.addEventListener('visibilitychange', schedule);
    controllers.set(section, () => {
      cancelAnimationFrame(frame); resize.disconnect(); intersection.disconnect();
      document.removeEventListener('visibilitychange', schedule); controllers.delete(section);
    });
  }
  function init(root = document) {
    root.querySelectorAll('.tf-videos:not(.tf-videos--dark)').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((destroy, section) => { if (event.target.contains(section)) destroy(); });
  });
})();

/* Restore the native locale selector without changing translated content. */
(() => {
 if(customElements.get('localization-form'))return;
 customElements.define('localization-form',class extends HTMLElement {
  connectedCallback(){
   if(this.dataset.tfLocaleBound)return;this.dataset.tfLocaleBound='true';
   const button=this.querySelector('[data-disclosure-toggle]'),list=this.querySelector('.disclosure-list'),form=this.querySelector('form');
   if(!button||!list||!form)return;
   list.id='TfLocaleList-'+form.id;button.setAttribute('aria-controls',list.id);
   const close=()=>{this.removeAttribute('open');button.setAttribute('aria-expanded','false');};
   button.addEventListener('click',()=>{const open=!this.hasAttribute('open');this.toggleAttribute('open',open);button.setAttribute('aria-expanded',String(open));});
   this.addEventListener('keydown',event=>{if(event.key==='Escape'){close();button.focus();}});
   this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))close();});
   document.addEventListener('click',event=>{if(!this.contains(event.target))close();});
   this.querySelectorAll('[data-disclosure-option]').forEach(option=>option.addEventListener('click',event=>{
    const input=form.querySelector('[data-disclosure-input]');if(!input)return;
    event.preventDefault();input.value=option.dataset.value;
    const returnTo=form.querySelector('[name="return_to"]');if(returnTo)returnTo.value=location.pathname+location.search+location.hash;
    form.requestSubmit();
   }));
  }
 });
})();

/* Keep Cloud Search aligned with the native mobile header field. */
(() => {
 let pending=false;
 const update=()=>{pending=false;if(!document.querySelector('.cloud-search-mobile')||!matchMedia('(max-width:1023px)').matches)return;
 const field=document.querySelector('.header predictive-search.search__form');if(!field)return;
 const r=field.getBoundingClientRect(),style=document.documentElement.style;
 style.setProperty('--tf-search-top',Math.max(0,r.top)+'px');style.setProperty('--tf-search-left',r.left+'px');style.setProperty('--tf-search-width',r.width+'px');
 };
 const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
 new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
 addEventListener('resize',schedule);addEventListener('scroll',schedule,{passive:true});
 if(window.visualViewport){visualViewport.addEventListener('resize',schedule);visualViewport.addEventListener('scroll',schedule);}
})();
